import { Shopify } from "@/types/general";
import { transformResponse } from "../../api/internalApiSlice";
import { integrationsApi } from "./integrationsApi";

export const shopifyApi = integrationsApi.injectEndpoints({
    endpoints: (builder) => ({
        shopifyOAuthInstall: builder.mutation<
            Shopify.DTO.OAuth.InstallResponse,
            Shopify.DTO.OAuth.InstallRequest
        >({
            query: (data) => ({
                url: "integrations/shopify/oauth/install",
                method: "POST",
                data,
            }),
            invalidatesTags: [{ type: "Integrations", id: "LIST" }],
            transformResponse,
        }),

        getShopifyLocations: builder.query<Shopify.Location[], void>({
            query: () => ({
                url: `integrations/shopify/locations`,
            }),
            providesTags: [{ type: "Integrations", id: "ShopifyLocations" }],
            transformResponse,
        }),

        getShopifyLocationMappings: builder.query<Shopify.Augmentations.Mapping.Root[], void>({
            query: () => ({
                url: `integrations/shopify/mappings`,
            }),
            providesTags: [{ type: "Integrations", id: "ShopifyMappings" }],
            transformResponse,
        }),

        updateShopifyLocationsMapping: builder.mutation<
            void,
            Shopify.Augmentations.Mapping.DTO.Update
        >({
            query: (data) => ({
                url: "integrations/shopify/mappings",
                method: "PUT",
                data,
            }),
            invalidatesTags: [
                { type: "Integrations", id: "ShopifyLocations" },
                { type: "Integrations", id: "ShopifyMappings" },
            ],
            transformResponse,
        }),

        importShopifyData: builder.mutation<void, Shopify.DTO.Import>({
            query: (data) => ({
                url: "data-transfer/integrations/shopify/import",
                method: "POST",
                data: {
                    entities: data.entities,
                    ...(data.reimport_confirmed && { reimport_confirmed: true }),
                },
            }),
            invalidatesTags: [{ type: "Integrations", id: "LIST" }],
            transformResponse,
        }),
    }),
});

export const {
    useShopifyOAuthInstallMutation,
    useGetShopifyLocationsQuery,
    useGetShopifyLocationMappingsQuery,
    useUpdateShopifyLocationsMappingMutation,
    useImportShopifyDataMutation,
} = shopifyApi;
